export const statusStyles = () => ({
  '&.MuiAlert-root': {
    padding: '5px 10px',
    borderRadius: '500px',
    '&:empty': {
      display: 'none',
    },
    '.MuiAlert-icon, .MuiAlert-message': {
      padding: '0',
    },
    '.MuiAlert-icon': {
      marginRight: '7px',
    },
    '.MuiAlert-message': {
      fontSize: '11px',
      lineHeight: '22px',
    },
    '&.dn-status-no-bg': {
      background: 'transparent !important',
    },
    '&.dn-status-blocked': {
      background: 'rgba(220, 20, 60, 0.08)',
      svg: {
        color: '#DC143C',
        fontSize: '18px',
      },
    },
    '&.dn-status-fail': {
      background: 'rgba(220, 20, 60, 0.08)',
      svg: {
        color: '#DC143C',
        fontSize: '18px',
      },
    },
    '&.dn-status-active': {
      background: 'rgba(0, 160, 59, 0.08)',
      svg: {
        color: '#00A03B',
        fontSize: '18px',
      },
    },
    '&.dn-status-inactive': {
      background: 'rgba(205, 205, 205, 0.08)',
      svg: {
        color: '#CDCDCD',
        fontSize: '18px',
      },
    },
    '&.dn-status-unauthorized': {
      background: 'rgba(255, 160, 47, 0.08)',
      svg: {
        color: '#FFA02F',
        fontSize: '18px',
      },
    },
    '&.dn-status-pending': {
      background: 'rgba(254, 176, 80, 0.08)',
      svg: {
        color: '#FEB050',
        fontSize: '18px',
      },
    },
    '&.dn-status-updating_transactions': {
      background: 'rgba(254, 176, 80, 0.08)',
      svg: {
        color: '#FEB050',
        fontSize: '18px',
      },
    },
    '&.dn-status-pending_device_registration': {
      background: 'rgba(254, 176, 80, 0.08)',
      svg: {
        color: '#FEB050',
        fontSize: '18px',
      },
    },
    '&.dn-status-updating_assets': {
      background: 'rgba(254, 176, 80, 0.08)',
      svg: {
        color: '#FEB050',
        fontSize: '18px',
      },
    },
    '&.dn-status-processing': {
      background: 'rgba(0, 158, 255, 0.08)',
      svg: {
        color: '#009EFF',
        fontSize: '18px',
      },
    },
  },
  span: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '11px',
    lineHeight: '100%',
    textAlign: 'center',
    color: '#4B4B4B',
  },
  '&.MuiAlert-root.dn-no-title': {
    borderRadius: '500px',
    padding: '6px',
    '.MuiAlert-icon': {
      padding: 0,
      margin: '0 !important',
    },
  },
});
